"use client";

import { faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setUserInteractionDataAttribute } from "@shared/constants";

import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import Fieldset from "@ui/js/components/form/fieldset";
import { Tile } from "@ui/js/components/tiles/tile";
import { Field, useFormikContext } from "formik";

const INPUT_ID_AND_LABEL_HTMLFOR = "student-loan-debt";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function StudentLoanDebt() {
	const { setFieldValue } = useFormikContext();
	const handleClick = (e: any) => {
		setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
	};
	return (
		<Fieldset legend="Do you currently have student loan debt?">
			<Field
				type="hidden"
				name={FIELD_NAME_SELECTOR}
				id={INPUT_ID_AND_LABEL_HTMLFOR}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__Yes`,
				)}
				iconLeft={<FontAwesomeIcon icon={faThumbsUp} className="text-lg" />}
				label="Yes"
				value="Yes"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__No`,
				)}
				iconLeft={<FontAwesomeIcon icon={faThumbsDown} className="text-lg" />}
				label="No"
				value="No"
				onClick={handleClick}
			/>
		</Fieldset>
	);
}
